import Sobrantes from "./Sobrantes";
export default Sobrantes;